module.exports = __webpack_public_path__ + "static/img/catalog_settings_type.75626a2f.png";